import { Controller } from "stimulus"
import { takeRegisteredEmail } from "./portal_registered_email"

// 登入頁的「Portal 帳號已建立」提示。文案由 Rails i18n 在 SSR 就渲染好（藏著），
// 這裡只負責在「本分頁剛註冊完跳過來」時把它顯示出來，順便回填 email。
export default class extends Controller {
  static targets = ["notice", "email"]

  connect() {
    const email = takeRegisteredEmail()
    if (email === null) return

    this.noticeTarget.classList.remove('hidden')
    if (this.hasEmailTarget && email) this.emailTarget.value = email
  }
}
